module.exports = "/davinci/assets/3e3c3661c5df298c0b4baaf09817a40c.png";